// ── 직원 관리 — 일괄등록 스프레드시트 스타일 상수 ─────────────────────────────

/* 일괄등록 안내 박스: 연한 배경으로 사용 방법 안내 */
export const guideBoxStyle = {
  padding: 12,
  borderRadius: 10,
  border: '1px solid var(--border)',
  background: 'var(--bg-subtle)',
};

/* 스프레드시트 테이블 래퍼: 스크롤 가능한 영역, 최대 높이 제한 */
export const sheetWrapStyle = {
  overflow: 'auto',
  border: '1px solid var(--border)',
  borderRadius: 10,
  maxHeight: '58vh',
  background: 'var(--bg-card)',
};

/* 스프레드시트 테이블: 콘텐츠 너비에 맞게 확장, 셀 간격 제거 */
export const sheetTableStyle = {
  width: 'max-content',
  minWidth: '100%',
  borderCollapse: 'separate',
  borderSpacing: 0,
};

/* 스프레드시트 인덱스 헤더: 좌측/상단에 고정되는 행 번호 헤더 셀 */
export const sheetIndexHeaderStyle = {
  position: 'sticky',
  left: 0,
  top: 0,
  background: 'var(--bg-subtle)',
  zIndex: 3,
  minWidth: 46,
  borderBottom: '1px solid var(--border)',
  borderRight: '1px solid var(--border)',
};

/* 스프레드시트 열 헤더: 상단에 고정되는 컬럼 레이블 셀 */
export const sheetHeaderStyle = {
  position: 'sticky',
  top: 0,
  background: 'var(--bg-subtle)',
  zIndex: 2,
  minWidth: 150,
  borderBottom: '1px solid var(--border)',
  borderRight: '1px solid var(--border)',
  padding: 8,
  textAlign: 'left',
};

/* 스프레드시트 인덱스 셀: 좌측에 고정되는 행 번호 데이터 셀 */
export const sheetIndexCellStyle = {
  position: 'sticky',
  left: 0,
  zIndex: 1,
  background: 'var(--bg-subtle)',
  textAlign: 'center',
  fontWeight: 600,
  borderRight: '1px solid var(--border)',
  borderBottom: '1px solid var(--border)',
  padding: '0 8px',
};

/* 스프레드시트 데이터 셀: 패딩 없는 셀 컨테이너 (내부 input이 꽉 채움) */
export const sheetCellStyle = {
  borderRight: '1px solid var(--border)',
  borderBottom: '1px solid var(--border)',
  padding: 0,
  background: 'var(--bg-card)',
};

/* 스프레드시트 입력 필드: 셀 전체를 채우는 테두리 없는 입력 필드 */
export const sheetInputStyle = {
  width: '100%',
  minWidth: 150,
  height: 36,
  border: 'none',
  outline: 'none',
  padding: '6px 8px',
  fontSize: 13,
  background: 'var(--bg-card)',
};

/* 스프레드시트 오류 입력 필드: 빨간 인셋 테두리와 연한 빨간 배경으로 유효성 오류 표시 */
export const errorInputStyle = {
  ...sheetInputStyle,
  background: 'rgba(239,68,68,0.08)',
  boxShadow: 'inset 0 0 0 1px #ef4444',
};
